import script from "./AddProductFiltersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProductFiltersModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddProductFiltersModal.vue?vue&type=style&index=0&id=792a17cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792a17cd"]])

export default __exports__